import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Divider } from '../../components/pbg-ui-library';
import { formatMessage } from '../../../lib/intl';

import { i18n } from './single-payer-payment.i18n';
import ContactInformation from './contact-information';
import PaymentMethod from './payment-method';

class SinglePayerPaymentForm extends React.PureComponent {
  formatMessage = formatMessage(this.props.intl ? this.props.intl : {});

  static propTypes = {
    accountType: PropTypes.string.isRequired,
    onCardError: PropTypes.func.isRequired,
    onCardTokenized: PropTypes.func.isRequired,
    onSignIn: PropTypes.func.isRequired,
    onLogout: PropTypes.func.isRequired,
    onCreateAccount: PropTypes.func.isRequired,
    connectWithFacebook: PropTypes.func.isRequired,
    onSendLink: PropTypes.func.isRequired,
    user: PropTypes.object,
  };

  renderContactInformationSection() {
    const {
      accountType, user, onLogout, onSignIn, onCreateAccount, connectWithFacebook
    } = this.props;

    return (
      <div className="contact-information">
        <ContactInformation
          accountType={accountType}
          user={user}
          onLogout={onLogout}
          onSignIn={onSignIn}
          onCreateAccount={onCreateAccount}
          onSendLink={this.props.onSendLink}
          connectWithFacebook={connectWithFacebook}
        />
      </div>
    );
  }

  renderPaymentMethodSection() {
    const { onCardTokenized, onCardError } = this.props;
    return (
      <PaymentMethod
        formName={SinglePayerPaymentFormName}
        onCardTokenized={onCardTokenized}
        onCardError={onCardError}
      />
    );
  }

  render() {
    return (
      <div className="single-payer-payment-form">
        <h3 className="form-title pbg-consumer-desktop pbg-desktop-heading-3">
          {this.formatMessage(i18n.enterDetails)}
        </h3>
        <Divider label={this.formatMessage(i18n.contactInformationTitle)} />
        {this.renderContactInformationSection()}
        <Divider label={this.formatMessage(i18n.paymentMethodTitle)} />
        {this.renderPaymentMethodSection()}
      </div>
    );
  }
};

export const SinglePayerPaymentFormName = 'singlePayerPaymentForm';

export default injectIntl(SinglePayerPaymentForm)



// WEBPACK FOOTER //
// ./src/desktop/pages/single-payer-payment/single-payer-payment-form.js